import { axiosClient } from "./axiosClient"

export const WEIGHT_PATH = '/api/v1/weight'

export const addWeight = (body) => {
    return axiosClient.post(WEIGHT_PATH, body)
}

export const updateWeight = (id, body) => {
    return axiosClient.put(`${WEIGHT_PATH}/${id}`, body)
}

export const deleteWeight = (id) => {
    return axiosClient.delete(`${WEIGHT_PATH}/${id}`)
}

export const getWeightById = (id) => {
    return axiosClient.get(`${WEIGHT_PATH}/${id}`)
}

export const getPageWeights = ({ search = '', lastId = '', id = "", code = '', name = '' }) => {
    return axiosClient.get(`${WEIGHT_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
}

export const uploadWeightExcelFile = (body) => {
    return axiosClient.post(`${WEIGHT_PATH}/upload-excel`, body)
}

export const downloadWeightExcelFile = () => {
    return axiosClient.get(`${WEIGHT_PATH}/download-excel`, {
        responseType: 'arraybuffer',
    })
}